/** 导航语言选择器选项（展示用；无独立语言包时回退 en） */
/** flag：统一两位字母区域码，避免 emoji 与文字混排导致字号不一致 */
/** label：本地文字；nameZh：中文名（列表副标题，便于查找如 العربية） */
export const LOCALE_OPTIONS = [
  {
    code: 'en',
    acceptLanguage: 'en-US',
    flag: 'EN',
    label: 'English',
    nameZh: '英语',
    region: '美国 / 英国',
  },
  {
    code: 'ar',
    acceptLanguage: 'ar-SA',
    flag: 'SA',
    label: 'العربية',
    nameZh: '阿拉伯语',
    region: '中东 / 北非',
  },
  {
    code: 'bn',
    acceptLanguage: 'bn-BD',
    flag: 'BD',
    label: 'বাংলা',
    nameZh: '孟加拉语',
    region: '孟加拉国',
  },
  {
    code: 'de',
    acceptLanguage: 'de-DE',
    flag: 'DE',
    label: 'Deutsch',
    nameZh: '德语',
    region: '德国',
  },
  {
    code: 'es',
    acceptLanguage: 'es-ES',
    flag: 'ES',
    label: 'Español',
    nameZh: '西班牙语',
    region: '西班牙 / 拉美地区',
  },
  {
    code: 'fr',
    acceptLanguage: 'fr-FR',
    flag: 'FR',
    label: 'Français',
    nameZh: '法语',
    region: '法国',
  },
  {
    code: 'hi',
    acceptLanguage: 'hi-IN',
    flag: 'IN',
    label: 'हिन्दी',
    nameZh: '印地语',
    region: '印度',
  },
  {
    code: 'id',
    acceptLanguage: 'id-ID',
    flag: 'ID',
    label: 'Bahasa Indonesia',
    nameZh: '印度尼西亚语',
    region: '印度尼西亚',
  },
  {
    code: 'it',
    acceptLanguage: 'it-IT',
    flag: 'IT',
    label: 'Italiano',
    nameZh: '意大利语',
    region: '意大利',
  },
  {
    code: 'ja',
    acceptLanguage: 'ja-JP',
    flag: 'JP',
    label: '日本語',
    nameZh: '日语',
    region: '日本',
  },
  {
    code: 'ko',
    acceptLanguage: 'ko-KR',
    flag: 'KR',
    label: '한국어',
    nameZh: '韩语/朝鲜语',
    region: '韩国',
  },
  {
    code: 'pl',
    acceptLanguage: 'pl-PL',
    flag: 'PL',
    label: 'Polski',
    nameZh: '波兰语',
    region: '波兰',
  },
  {
    code: 'pt',
    acceptLanguage: 'pt-BR',
    flag: 'BR',
    label: 'Português',
    nameZh: '葡萄牙语',
    region: '巴西 / 葡萄牙',
  },
  {
    code: 'ru',
    acceptLanguage: 'ru-RU',
    flag: 'RU',
    label: 'Русский',
    nameZh: '俄语',
    region: '俄罗斯',
  },
  {
    code: 'th',
    acceptLanguage: 'th-TH',
    flag: 'TH',
    label: 'ไทย',
    nameZh: '泰语',
    region: '泰国',
  },
  {
    code: 'tl',
    acceptLanguage: 'tl-PH',
    flag: 'PH',
    label: 'Tagalog',
    nameZh: '塔加洛语 / 菲律宾语',
    region: '菲律宾',
  },
  {
    code: 'uk',
    acceptLanguage: 'uk-UA',
    flag: 'UA',
    label: 'Українська',
    nameZh: '乌克兰语',
    region: '乌克兰',
  },
  {
    code: 'vi',
    acceptLanguage: 'vi-VN',
    flag: 'VN',
    label: 'Tiếng Việt',
    nameZh: '越南语',
    region: '越南',
  },
  {
    code: 'zh',
    acceptLanguage: 'zh-CN',
    flag: 'CN',
    label: '中文',
    nameZh: '简体中文',
    region: '中国大陆',
  },
  {
    code: 'zh-TW',
    acceptLanguage: 'zh-TW',
    flag: 'TW',
    label: '繁體中文',
    nameZh: '繁体中文',
    region: '中国台湾 / 中国香港',
  },
];

export const LOCALE_CODES = LOCALE_OPTIONS.map((item) => item.code);

const DEFAULT_OPTION = LOCALE_OPTIONS[0];

export function findLocaleOption(code) {
  return LOCALE_OPTIONS.find((item) => item.code === code) ?? DEFAULT_OPTION;
}

export function getAcceptLanguageTag(i18nCode) {
  return findLocaleOption(i18nCode).acceptLanguage;
}

/** acceptLanguage / navigator.language → vue-i18n locale code */
export function resolveI18nLocaleFromTag(tag) {
  const normalized = String(tag ?? '').trim();
  if (!normalized) return DEFAULT_OPTION.code;

  const exact = LOCALE_OPTIONS.find(
    (item) => item.acceptLanguage.toLowerCase() === normalized.toLowerCase()
  );
  if (exact) return exact.code;

  const byCode = LOCALE_OPTIONS.find(
    (item) => item.code.toLowerCase() === normalized.toLowerCase()
  );
  if (byCode) return byCode.code;

  const main = normalized.split('-')[0].toLowerCase();
  const byMain = LOCALE_OPTIONS.find((item) => item.code.toLowerCase() === main);
  if (byMain) return byMain.code;

  return DEFAULT_OPTION.code;
}
